import React from "react";

import { useTranslation } from "react-i18next";

import {Form, Card, Row, Col} from "react-bootstrap"
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { isNullUndefinedOrEmpty } from "../../common/Helpers";

const ProfileInfo = (props) => {

    const { t } = useTranslation();
    
    const userInfo = props.user;
    const jobPosition = props.jobPosition;

    return (
        <Card className='profile-info-form'>
            <Card.Header>
                <Card.Title className="d-flex justify-content-between">
                    <h4><b>{t('data-lang-boxname-information')}</b></h4>
                </Card.Title>
            </Card.Header>
            <Card.Body style={{width: "100%"}} className="profile-info-form-body">
                <Row style={{height: "100%"}}>
                    { userInfo && 
                        <Row>
                            <Col xl={6} className="px-4">
                                <Form.Label className="mb-4"><b>{userInfo.firstName} {userInfo.lastName}</b></Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-company')}:</b> {userInfo.company}</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-job')}:</b> {!isNullUndefinedOrEmpty(jobPosition) ? jobPosition : "S/I"}</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-email')}:</b> {userInfo.email}</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-phonenumber')}:</b> {userInfo.phoneNumber}</Form.Label>
                            </Col>
                            <Col xl={6} className="px-4">
                                <Form.Label className="mb-4">&nbsp;</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-dnirut')}:</b> {userInfo.dniRut}</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-languages')}:</b> {userInfo.languages}</Form.Label>
                                <Form.Label className="mt-2"><b>{t('data-lang-lbl-address')}:</b> {userInfo.address}</Form.Label>
                            </Col>
                        </Row>
                    }
                    { !userInfo &&
                        <Shimmer
                            customElementsGroup={
                            <Row>
                                <Col style={{ display: 'flex' }}>
                                <ShimmerElementsGroup
                                    flexWrap
                                    width="100%"
                                    shimmerElements={[
                                        { type: ShimmerElementType.line, width: '100%', height: 10, verticalAlign: 'bottom' },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                        { type: ShimmerElementType.line, width: '100%', height: 10 },
                                    ]}
                                />
                                </Col>
                            </Row>
                            }
                            styles={{
                                root: {
                                    width:"100%",
                                    height:"150px",
                                    backgroundColor: "white"}
                                }
                            }
                            className="pt-4"
                            isDataLoaded={userInfo !== null}>
                        </Shimmer>
                    }
                </Row>
            </Card.Body>
            <Card.Footer>
            </Card.Footer>
        </Card>
    );
};

export default ProfileInfo;